import { registryComponent } from '@boost-sd/components-registry/registry';
import { InnerHTMLRenderer as InnerHTMLRendererCore } from '@boost-sd/core-js';

export const InnerHTMLRenderer = registryComponent('InnerHTMLRenderer', InnerHTMLRendererCore);
